export default `
-- AlterTable
ALTER TABLE "Attachment" ADD COLUMN "hidden_at" DATETIME;
ALTER TABLE "Attachment" ADD COLUMN "index" INTEGER;

-- CreateIndex
CREATE INDEX "Attachment_index_idx" ON "Attachment"("index");

-- CreateIndex
CREATE INDEX "Attachment_hidden_at_idx" ON "Attachment"("hidden_at");
`;
